export default class UtilisateurPortailService {
    users;
    constructor($http) {
        this.$http = $http;
        this.url = `${__configuration.apiUrl}/massia/portail/utilisateur`;
        this.users = [];
    }

    getAll(filters = [], sorts = [], pagination = { skip: 0, take: 0 }, ordered = false) {
        filters = filters !== null ? filters : [];
        pagination = pagination !== null ? pagination : { skip: 0, take: 0 };
        sorts = sorts !== null ? sorts : [];

        return this.$http.get(this.url, {
            params: {
                filters: JSON.stringify(filters),
                sorts: JSON.stringify(sorts),
                pagination: JSON.stringify(pagination),
                ordered: ordered
            }
        });
    }

    getOne(id) {
        return this.$http.get(`${this.url}/${id}`);
    }

    create(data) {
        return this.$http.post(this.url, data);
    }

    update(id, data) {
        return this.$http.put(`${this.url}/${id}`, data);
    }

    delete(id) {
        return this.$http.delete(`${this.url}/${id}`);
    }
}

UtilisateurPortailService.$inject = ['$http'];
